import localForage from "localforage"
import { useEffect } from "react"

import { sessionForage } from "@/utils"

export const SETTINGS_KEYS = ["events_statistics_settings", "events_list_settings"] as const

const STORAGES = [sessionForage, localForage]

type SettingsKey = typeof SETTINGS_KEYS[number]

type Settings = Record<string, unknown>

function retrieveSessionSavedUserSettings<S extends Settings>(settingsKey: SettingsKey) {
  return sessionForage.getItem<S>(settingsKey)
}

export function useUserSettings<S extends Settings>(settingsKey: SettingsKey) {
  return retrieveSessionSavedUserSettings<S>(settingsKey)
}

function resaveUserSettingsToSession() {
  SETTINGS_KEYS.forEach(async (key) => {
    const settings = await localForage.getItem<Settings>(key)

    if (settings) sessionForage.setItem(key, settings)
  })
}

export function useResaveUserSettingsToSession() {
  useEffect(() => {
    resaveUserSettingsToSession()
  })
}

function saveUserSettings<S extends Settings>(settingsKey: SettingsKey, settingsToSet: Partial<S>) {
  const settings = retrieveSessionSavedUserSettings<S>(settingsKey)

  STORAGES.forEach((storage) => storage.setItem(settingsKey, { ...settings, ...settingsToSet }))
}

export function useSaveUserSettings<S extends Settings>(settingsKey: SettingsKey, settings: S) {
  useEffect(() => {
    saveUserSettings<S>(settingsKey, settings)
  }, [settingsKey, settings])
}
